import { ListingType } from '@libs/graphql/types'
import { SpaceTypeSlugs } from '@page/search/categories/search-categories.types'
import { ExperimentGroups } from '@services/server/experiment.types'

export type HomepageListingType = Extract<
  ListingType,
  | 'tennisCourt'
  | 'basketballCourt'
  | 'home'
  | 'pickleball'
  | 'pool'
  | 'largeBackyard'
  | 'igloo'
>

export enum HomepageSpaceTypeSlugs {
  Pool = SpaceTypeSlugs.Pool,
  Igloo = SpaceTypeSlugs.Igloos,
  Tennis = SpaceTypeSlugs.Tennis,
  Pickleball = SpaceTypeSlugs.Pickleball,
  Hoops = SpaceTypeSlugs.Hoops,
  Home = SpaceTypeSlugs.Home,
  PetParks = SpaceTypeSlugs.PetParks,
  LargeBackyard = 'largeBackyard',
}

export type TShvimply = {
  isShvimply: boolean
  shvimplyText: string
}

export type HomeProps = TShvimply & {
  isFall: boolean
  isSummerPassBanner?: boolean
  fallImage: ExperimentGroups
  isUGC: boolean
  /** Seeded from serverPath() so hub metadata/H1 match SSR (CH-02). */
  initialListingType?: HomepageListingType
  initialSpaceTypeSlug?: HomepageSpaceTypeSlugs
}
